export default __webpack_public_path__ + "static/media/Settings.1ff14c83.svg";